import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        flex: 'auto',
        overflow: 'hidden',
      },
      loading: {
        width: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 30,
      },
    }),
  { name: 'MensagensAssessor' }
);
